import * as yup from 'yup';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { urlRegex } from '@utils/regexs';

export const formSchema = yup.object().shape({
  firstName: yup
    .string()
    .max(50, 'First name is too long')
    .required('First name is required')
    .default(''),
  lastName: yup
    .string()
    .max(50, 'Last name is too long')
    .required('Last name is required')
    .default(''),
  email: yup
    .string()
    .email('Invalid email')
    .required('Email is required')
    .default(''),
  phoneNumber: yup
    .string()
    .required('Phone number is required')
    .default('')
    .test(
      'is-valid-phone-number',
      'Phone number is not valid.',
      (val: string | undefined) => {
        if (!val) return false;

        if (isValidPhoneNumber(val, 'US')) {
          return true;
        } else {
          return false;
        }
      }
    ),
  company: yup.string().required('Company name is required').default(''),
  numberOfListings: yup
    .number()
    .integer()
    .min(1, 'Number of Properties must be greater than 0')
    .required('Number of Properties is required'),
  pmsSoftware: yup
    .object()
    .shape({
      label: yup
        .string()

        .default(''),
      value: yup
        .string()

        .default(''),
    })
    .required('PM Software is required'),
  website: yup
    .string()
    .trim()
    .test('valid-url', 'Company website is not valid', (value) => {
      if (!value || value.length === 0) return true;
      return urlRegex.test(value);
    })
    .default(''),
});

export type FormSchema = yup.InferType<typeof formSchema>;

export const initialValues: FormSchema = formSchema.cast({
  email: '',
  firstName: '',
  lastName: '',
  company: '',
  phoneNumber: '',
  website: '',
  numberOfListings: 1,
});
